import {ChangeDetectorRef, Component, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RouterService, TAB} from '@npck/libs/commons';
import {Subject} from 'rxjs';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {Path} from '../../path';

@Component({
    templateUrl: 'admin.component.html',
    standalone: false
})
export class AdminComponent {
    @ViewChildren('tab') tab: QueryList<ElementRef>;
    tabs: AdminPanelTab[];
    activeTab: AdminPanelTab;
    buttonClickSubject = new Subject<AdminPanelTab>();
    selectedTabIndex: number;
    buttonText: string;

    constructor(
        private routerService: RouterService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private authHolderService: AuthHolderService,
    ) {
        this.tabs = this.buildTabs();
        const tabFromUrl = this.activatedRoute.snapshot.queryParamMap.get(TAB) as AdminPanelTab | null;
        this.activeTab = tabFromUrl && this.tabs.includes(tabFromUrl) ? tabFromUrl : this.tabs[0];
        this.selectedTabIndex = this.tabs.indexOf(this.activeTab);
    }

    handleNavigation($event: number): void {
        this.activeTab = this.tabs[$event];
        this.routerService.navigate(
            Path.ADMIN_PANEL,
            {
                queryParams: {[TAB]: this.activeTab},
                queryParamsHandling: 'merge',
            });
        (this.tab.first as any)?.ngOnDestroy();
    }

    handleButtonTextChanges(buttonText: string): void {
        this.buttonText = buttonText;
        this.cdr.detectChanges();
    }

    private buildTabs(): AdminPanelTab[] {
        if (this.authHolderService.hasAccess(['npck-admin'])) {
            return ['tabDictionaries', 'tabOrganizations', 'tabUsers', 'tabJobs'];
        }
        return ['tabUsers'];
    }
}

export declare type AdminPanelTab = 'tabDictionaries' | 'tabOrganizations' | 'tabUsers' | 'tabJobs';
